import React from 'react';
import CmmlDiagnosticCriteria from './CmmlDiagnosticCriteria';
import CmmlRiskScores from './CmmlRiskScores';

interface CmmlViewProps {
  activeTab: string;
}

const CmmlView: React.FC<CmmlViewProps> = ({ activeTab }) => {
  switch (activeTab) {
    case 'diagnosis':
      return <CmmlDiagnosticCriteria />;
    case 'risk':
      return <CmmlRiskScores />;
    default:
      return null;
  }
};

export default CmmlView;
